<template>
  <v-app>
    <v-stepper v-model="e1" class="quiz-wrapper elevation-0">
      <v-stepper-items>
        <v-stepper-content step="1" class="quiz-start">
          <v-row>
            <v-col  sm="12" md="8">
             <h1>szukamy pracownika –
               dołącz do mBanku!</h1>
              <h2>Zrób nasz quiz i przekonaj się, co Cię wyróżnia.<br>
                Nas wyróżniają ludzie.</h2>

            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="justify-start d-flex">
              <v-btn :x-large="true" :rounded="true"
                     elevation="0" class="start-btn" color="#cc0a0a" @click="setNextStep(false)">
                Rozpocznij Quiz <img src="../assets/arrow.png" alt="arrow">
              </v-btn>
            </v-col>
          </v-row>
        </v-stepper-content>

        <v-stepper-content
            v-for="step in quizSteps" :step="step.step" :key="step.step"
            :class="'no-padding step-'+ step.step+ ' question-step'">
          <v-row :no-gutters="true">
            <v-col cols="12" md="6" class="img-col">
            </v-col>
            <v-col cols="12" md="6"
                   class="d-flex justify-center align-center flex-column text-center">
              <div class="question-wrapper">
                <h2>Pytanie<br> <span class="steps-count">{{ step.questionNo }} z 4</span></h2>
                <p class="question">{{ step.question }}</p>
                <ul class="text-left answers">
                  <li v-for="(answer,answerIndex) in step.answers" :key="answer.label"
                      v-bind:class="{ selected: isSelected(step.step, answerIndex) }"
                      class="d-flex" @click="setNextStep(answer.cat, step.step, answerIndex)">
                    <v-avatar color="#cc0a0a" size="36">
                      <span class="white--text answer-label">{{ answer.label }}</span>
                    </v-avatar>
                    <p>{{ answer.text }}</p>
                  </li>
                </ul>
                <div class="question-footer text-right d-flex justify-end">
                  <span class="prev-bt" @click="setPrevStep" v-if="step.step !== 2">
                    <img src="../assets/arrow-left.png" alt="arrow"> Wróć
                  </span>
                </div>

              </div>
            </v-col>
          </v-row>
        </v-stepper-content>
        <v-stepper-content step="6" class="quiz-end">
          <v-row>
            <v-col cols="12" class="text-center result-content">
              <h2>Twój wynik</h2>
              <p>
                {{ quizResult.text1 }}<br>
                <strong class="result">{{ quizResult.text2 }}</strong>,<br>
                a nas wyróżniają ludzie.<br>
                <strong>Tacy jak Ty!</strong>
              </p>
              <v-btn :x-large="true" :rounded="true"
                     href="https://system.erecruiter.pl/FormTemplates/RecruitmentForm.aspx?WebID=b29e1bc57ac347c9aac50684be848549"
                     target="_blank"
                     elevation="0" class="join-btn" color="#cc0a0a" @click="startOver">
                Dołącz do mBanku
              </v-btn>
            </v-col>
          </v-row>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </v-app>
</template>

<script>
export default {
  name: 'Quiz',
  data() {
    return {
      e1: 1,
      results: [
        {
          text1: 'Wyróżniają Cię',
          text2: 'precyzja i sumienność',
        },
        {
          text1: 'Wyróżniają Cię',
          text2: 'ciekawość i otwartość na wyzwania',
        },
        {
          text1: 'Wyróżnia Cię',
          text2: 'łatwość nawiązywania kontaktów',
        },
      ],
      answers: {
        1: 0,
        2: 0,
        3: 0,
      },
      selected: [],
      quizSteps: [
        {
          step: 2,
          questionNo: 1,
          question: 'Szef poszukuje ochotników do wykonania\n'
              + 'nietypowego zadania. Co robisz?',
          answers: [
            {
              label: 'a',
              cat: 1,
              selected: false,
              text: 'Dokładnie analizujesz, czy masz czas\n'
                  + 'i umiejętności żeby mu sprostać. ',
            },
            {
              label: 'b',
              cat: 2,
              selected: false,
              text: 'Zgłaszasz się zanim dokończy opowiadać\n'
                  + 'o szczegółach. Uwielbiasz wyzwania!',
            },
            {
              label: 'c',
              cat: 3,
              selected: false,
              text: 'Zbierasz zespół. Razem na pewno\n'
                  + 'dacie radę!',
            },
          ],
        },
        {
          step: 3,
          questionNo: 2,
          question: 'Planujecie urodzinową imprezę niespodziankę dla koleżanki z pracy. Jaka jest Twoja rola?',
          answers: [
            {
              label: 'a',
              cat: 1,
              selected: false,
              text: 'Przygotowujesz harmonogram działań\n'
                  + 'i pełnisz funkcję skarbnika. Zwracasz uwagę,\n'
                  + 'że lot balonem to nienajlepszy pomysł na prezent.',
            },
            {
              label: 'b',
              cat: 2,
              selected: false,
              text: 'Zasypujesz wszystkich propozycjami\n'
                  + 'na nietypowy motyw przewodni. Żałujesz,\n'
                  + 'że odrzucono lot balonem. To by była przygoda!',
            },
            {
              label: 'c',
              cat: 3,
              selected: false,
              text: 'Motywujesz współpracowników do\n'
                  + 'zaangażowania i rozdzielasz zadania.\n'
                  + 'Namówiłeś nawet największego zespołowego marudę.',
            },
          ],
        },
        {
          step: 4,
          questionNo: 3,
          question: 'Jak wyobrażasz sobie wymarzony wyjazd\n'
              + 'integracyjny?',
          answers: [
            {
              label: 'a',
              cat: 1,
              selected: false,
              text: 'Ciekawe szkolenia i wykłady.\n'
                  + 'Wieczorem sudoku.',
            },
            {
              label: 'b',
              cat: 2,
              selected: false,
              text: 'Escape room, park rozrywki, karaoke…\n'
                  + 'Dużo wrażeń!',
            },
            {
              label: 'c',
              cat: 3,
              selected: false,
              text: 'Gry i zabawy zespołowe.\n'
                  + 'Chętnie sam je przeprowadzisz.',
            },
          ],
        },
        {
          step: 5,
          questionNo: 4,
          question: 'Jesteś pierwszy dzień w nowej pracy.\n'
              + 'Na czym się skupiasz?',
          answers: [
            {
              label: 'a',
              cat: 1,
              selected: false,
              text: 'Na zakresie obowiązków, procedurach, zasadach.\n'
                  + 'Zaraz… to można na czymś innym?',
            },
            {
              label: 'b',
              cat: 2,
              selected: false,
              text: 'Na zadaniach, które są dla Ciebie nowością.\n'
                  + 'Będziesz mógł się tyle nauczyć! ',
            },
            {
              label: 'c',
              cat: 3,
              selected: false,
              text: 'Na koleżankach i kolegach! Już po pierwszej kawie\n'
                  + 'wszyscy Cię znają i zaplanowaliście wspólne\n'
                  + 'wyjście do kina w weekend.',
            },
          ],
        },
      ],
    };
  },
  methods: {
    setNextStep(answerCat = false, step = false, answerIndex = false) {
      if (answerCat) {
        const stepFilled = this.selected.findIndex((selected) => selected.step === step);
        if (stepFilled > -1) {
          this.answers[this.selected[stepFilled].cat] -= 1;
          this.selected.splice(stepFilled, 1);
        }

        this.selected.push({
          step,
          answer: answerIndex,
          cat: answerCat,
        });
        this.answers[answerCat] += 1;
      }
      this.e1 += 1;
    },
    isSelected(step, answer) {
      const isSelected = this.selected.find((selected) => {
        if (selected.step === step && selected.answer === answer) {
          return true;
        }
        return false;
      });

      return isSelected;
    },
    setPrevStep() {
      this.e1 -= 1;
    },
    startOver() {
      this.e1 = 1;
      this.selected = [];
    },
  },
  computed: {
    quizResult() {
      const { answers } = this;

      const resultNo = Object.keys(answers).reduce((a, b) => (answers[a] > answers[b] ? a : b));

      return this.results[(resultNo - 1)];
    },
  },
};
</script>

<style lang="scss" scoped>
  @font-face {
    font-family: FS Lola;
    font-style: normal;
    font-weight: 300;
    src: url('../assets/fonts/fs_lola-light-webfont.woff2') format("woff2"),
    url('../assets/fonts/fs_lola-light-webfont.woff') format("woff"),
    url('../assets/fonts/fs_lola-light-webfont.ttf') format("truetype");
    //url('../assets/fonts/fs_lola-light-webfont.svg#fs_lolalight') format("svg")
  }

  @font-face {
    font-family: FS Lola;
    font-style: normal;
    font-weight: 400;
    src: url('../assets/fonts/fs_lola-regular-webfont.woff2') format("woff2"),
    url('../assets/fonts/fs_lola-regular-webfont.woff') format("woff"),
    url('../assets/fonts/fs_lola-regular-webfont.ttf') format("truetype");
    //url(../assets/fonts/fs_lola-regular-webfont.svg#fs_lolaregular) format("svg")
  }

  @font-face {
    font-family: FS Lola;
    font-style: normal;
    font-weight: 500;
    src: url('../assets/fonts/fs_lola-medium-webfont.woff2') format("woff2"),
    url('../assets/fonts/fs_lola-medium-webfont.woff') format("woff"),
    url('../assets/fonts/fs_lola-medium-webfont.ttf') format("truetype");
    //url(../assets/fonts/fs_lola-medium-webfont.svg#fs_lolamedium) format("svg")
  }

  @font-face {
    font-family: FS Lola;
    font-style: normal;
    font-weight: 700;
    src: url('../assets/fonts/fs_lola-bold-webfont.woff2') format("woff2"),
    url('../assets/fonts/fs_lola-bold-webfont.woff') format("woff"),
    url('../assets/fonts/fs_lola-bold-webfont.ttf') format("truetype");
    //url(../assets/fonts/fs_lola-bold-webfont.svg#fs_lolaregular) format("svg")
  }

  @font-face {
    font-family: 'mBank';
    src: url('../assets/fonts/subset-mBank-SemiBoldItalic.woff2') format('woff2'),
    url('../assets/fonts/subset-mBank-SemiBoldItalic.woff') format('woff');
    font-weight: 600;
    font-style: italic;
    font-display: swap;
  }

  @font-face {
    font-family: 'mBank';
    src: url('../assets/fonts/subset-mBank-Regular.woff2') format('woff2'),
    url('../assets/fonts/subset-mBank-Regular.woff') format('woff');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'mBank';
    src: url('../assets/fonts/subset-mBank-Light.woff2') format('woff2'),
    url('../assets/fonts/subset-mBank-Light.woff') format('woff');
    font-weight: 300;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'mBank';
    src: url('../assets/fonts/subset-mBank-Bold.woff2') format('woff2'),
    url('../assets/fonts/subset-mBank-Bold.woff') format('woff');
    font-weight: bold;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'mBank';
    src: url('../assets/fonts/subset-mBank-BoldItalic.woff2') format('woff2'),
    url('../assets/fonts/subset-mBank-BoldItalic.woff') format('woff');
    font-weight: bold;
    font-style: italic;
    font-display: swap;
  }

  @font-face {
    font-family: 'mBank';
    src: url('../assets/fonts/subset-mBank-Italic.woff2') format('woff2'),
    url('../assets/fonts/subset-mBank-Italic.woff') format('woff');
    font-weight: normal;
    font-style: italic;
    font-display: swap;
  }

  @font-face {
    font-family: 'mBank';
    src: url('../assets/fonts/subset-mBank-SemiBold.woff2') format('woff2'),
    url('../assets/fonts/subset-mBank-SemiBold.woff') format('woff');
    font-weight: 600;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'mBank';
    src: url('../assets/fonts/subset-mBank-LightItalic.woff2') format('woff2'),
    url('../assets/fonts/subset-mBank-LightItalic.woff') format('woff');
    font-weight: 300;
    font-style: italic;
    font-display: swap;
  }

  .quiz-start {
    display: flex;
    align-items: center;
    // background-image: url('../assets/mbank-ludzie-rgb.png');
    background-image: url('../assets/mbank-quiz-start.jpg');
    //background-position: right 50px top 50px;
    background-position: right 50px center;
    padding:50px;
    background-size: 25vw;

    @media screen and (max-width: 768px) {
      background-position: top 10px center;
      background-size: 60%;
      padding: 10px;
      height: 100vh !important;
      align-items: flex-end;
      h1 {
        font-size: 20px;
        margin-top: 50px;
      }

      h2 {
        text-align: center;
      }
    }

  }

  .quiz-wrapper, .v-stepper__content {
    min-height: 100vh;
    font-family: 'mBank', sans-serif;
    @media screen and (max-width: 768px) {
      height: auto;
    }

    .stepper-items {
      height:100%;
    }

    h1 {
      color: #000000;
      //font-size: 85px;
      font-size: clamp(65px, 5vw, 85px);
      letter-spacing: 0;
      line-height: 1em;
      margin-bottom:30px;

      @media screen and (max-width: 768px) {
          font-size: 40px;
          text-align: center;
      }

      @media screen and (max-width:330px){
        font-size: 20px;
      }
    }

    h2 {
      //font-size: 40px;
      font-size: clamp(30px, 3.5vw, 40px);
      color:#1e1e1e;
      line-height: 1em;
      font-weight: normal;

      @media screen and (max-width: 768px) {
        font-size: 20px;
      }
    }

    .start-btn {
      background-color: #cc0a0a;
      //font-size: 50px;
      font-size: clamp(40px, 3vw, 50px);
      color:#fff;
      font-weight: bold;
      text-transform: none;
      letter-spacing: 0;
      height: auto !important;
      display: flex;
      align-content: center;
      align-items: center;
      border-radius: 45px;
      padding-top:10px !important;
      padding-bottom:10px !important;

      @media screen and (max-width: 768px) {
        width: 100% !important;
        font-size: 25px;
      }

      img {
        margin-left:10px;
        /*width: 50px;*/

        @media screen and (max-width: 768px) {
          width: 20px;
        }
      }
    }

    .join-btn {
      background-color: #cc0a0a;
      font-size: 50px;
      color:#fff;
      font-weight: bold;
      text-transform: none;
      letter-spacing: 0;
      height: auto !important;
      border-radius: 45px;
      padding-top:10px !important;
      padding-bottom:10px !important;

      @media screen and (max-width: 768px) {
        font-size: 30px;
        width: 100% !important;
      }
    }

    .no-padding {
      padding:0;
    }

    .question-step {
      h2  {
        color: #c00f1b;
        //font-size: 70px;
        font-size: clamp(55px,4vw,70px);
        //margin-bottom:60px;
        margin-bottom: 3vh;

        @media screen and (max-width: 768px) {
          font-size: 50px;
          margin-bottom: 30px;
        }

        .steps-count {
          font-size: 60px;
          @media screen and (max-width: 768px) {
            font-size: 40px;
          }
        }
      }
      .v-stepper__wrapper {
        height: 100%;
      }

      .question {
        //font-size: 35px;
        font-weight: bold;
        color:#525455;
        line-height: 1em;
        letter-spacing: 0;
        margin-bottom: 50px;
        font-size: clamp(25px,3vw,35px);

        @media screen and (max-width: 768px) {
          font-size: 25px;
        }
      }

      .question-wrapper {
        padding-left: 50px;
        padding-right: 50px;

        @media screen and (max-width: 768px) {
          padding-left: 10px;
          padding-right: 10px;
        }
      }

      .prev-bt {
        font-weight: bold;
        font-size: 30px;
        display: flex;
        align-content: center;
        align-items: center;
        cursor: pointer;
        color: #525455;
        img {
          margin-right: 10px;
        }

        @media screen and (max-width: 768px) {
          font-size: 24px;
        }
      }

    }

    .img-col {
      min-height: 100vh;
      background-size: cover;
      @media screen and (max-width: 768px) {
        height:auto;
      }
    }

    .step-2 {
      .img-col {
        background-image: url('../assets/step-1.png');
      }
    }

    .step-3 {
      .img-col {
        background-image: url('../assets/step-2.png');
      }
    }

    .step-4 {
      .img-col {
        background-image: url('../assets/step-3.png');
      }
    }

    .step-5 {
      .img-col {
        background-image: url('../assets/step-4.png');
      }
    }

    .answers {
      list-style: none;
      li {
        margin-bottom:30px;
        font-size: 26px;
        color: #525455;
        line-height: 1em;
        align-items: center;
        cursor: pointer;

        &:hover, &.selected {
          font-weight: 500;
        }

        p {
          margin-bottom: 0;
        }

        .v-avatar {
          margin-right:10px;
          .answer-label {
            font-weight: bold;
            font-size: 25px;
          }
        }

      }

      @media screen and (max-width: 768px) {
        padding-left:0;
        p {
          font-size: 20px;
        }
      }
    }

    .quiz-end {
      h2 {
        color:#525455;
        margin-bottom:50px;
        font-size: 70px;

        @media screen and (max-width: 768px) {
          font-size: 40px;
          margin-bottom: 35px;
        }

      }

      p {
        color:#525455;
        font-size: 50px;
        margin-bottom: 50px;
        line-height: 1.2em;
        letter-spacing: 0;
        .result {
          color: #c00f1b;
          text-transform: uppercase;
        }

        @media screen and (max-width: 768px) {
          font-size: 40px;
        }

        @media screen and (max-width: 330px) {
          font-size: 30px;
        }

      }

      .result-content {
        height: 100vh;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
      }
    }
  }
</style>
